import Main from '../../types/enums/main';
import mediaProductionRequest from './mediaProductionRequest';
import { Observable } from 'rxjs';

const WAITING_TIME = 100;

function mediaProductionObservable(
  id: string,
  seasonNumber?: number,
  isRecord?: boolean
) {
  return new Observable((subscriber) => {
    mediaProductionRequest(id, seasonNumber, isRecord).then((data) => {
      setTimeout(() => {
        subscriber.next({ data, type: Main.RAILS });
        subscriber.complete();
      }, WAITING_TIME);
    });
  });
}
export default mediaProductionObservable;
